import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

const AppLink = ({ to, className, children, onClick, ...props }) => {
  const navigate = useNavigate();

  const handleClick = useCallback((e) => {
    e.preventDefault();
    if (onClick) onClick(e);
    navigate(to);
  }, [to, navigate, onClick]);

  return (
    <span 
      role="link"
      tabIndex={0}
      className={`cursor-pointer ${className || ''}`}
      onClick={handleClick}
      onKeyDown={(e) => { if (e.key === 'Enter') handleClick(e); }}
      data-href={to}
      {...props}
    >
      {children}
    </span>
  );
};

export default AppLink;
